module.exports = __webpack_public_path__ + "img/chai.83dce08c.png";